import React from 'react';
import { DatePicker } from 'antd';
import { useTranslation } from 'react-i18next';
import './rangePicker.scss';
// Date Format Library-
import { Dayjs } from 'dayjs';

const { RangePicker } = DatePicker;

interface RangePickerComponentProps {
    value?: any;
    className?: string;
    onChangeEvent?: (value: any) => void;
    style?: React.CSSProperties;
    format?: string;
    showTime?: boolean;
    disabledDate?: (current: any) => boolean;
    disabledTime?: (date: any, range: 'start' | 'end', info: {
            from?: any;
        }) => any;
    onCalendarChange?: (dates: any, dateStrings: string[]) => void;
    allowClear?: boolean;
    placeholder?: [string, string];
    popupClassName?: string
    defaultValue?: [Dayjs, Dayjs] | undefined
}

const RangePickerComponent = ({
    value = '',
    className = '',
    onChangeEvent = () => {},
    style = {},
    format = 'DD-MMM-YYYY',
    showTime,
    disabledDate,
    disabledTime,
    onCalendarChange,
    allowClear = false,
    placeholder,
    popupClassName = '',
    defaultValue = undefined
}: RangePickerComponentProps) => {
    const { t } = useTranslation();
    const resolvedPlaceholder: [string, string] = placeholder ?? [t('shared.rangePicker.startDate'), t('shared.rangePicker.endDate')];
    return (
        <>
            <RangePicker
                className={className}
                value={value}
                onChange={onChangeEvent}
                style={style}
                format={format}
                showTime={showTime}
                disabledDate={disabledDate}
                disabledTime={disabledTime}
                onCalendarChange={onCalendarChange}
                allowClear={allowClear}
                placeholder={resolvedPlaceholder}
                classNames={{ popup: { root: popupClassName } }}
                defaultValue={defaultValue}
            />
        </>
    );
};

export default RangePickerComponent;
